import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import InterviewLogDetailContent from "../../../components/AdminPanel/InterviewLogDetail/InterviewLogDetailContent";
import { ROUTES } from "../../../helpers/utils/Constants/route";

const InterviewLogDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <AdminPanelLayout>
        <div className="error-container">
          <h2>Interview ID not found</h2>
          <button type="button" onClick={() => navigate(ROUTES.INTERVIEW_LOGS)}>
            Back to Interview Logs
          </button>
        </div>
      </AdminPanelLayout>
    );
  }

  return (
    <AdminPanelLayout>
      <InterviewLogDetailContent interviewId={id} />
    </AdminPanelLayout>
  );
};

export default InterviewLogDetail;

